import { render } from "./TreatmentPlanForm.vue?vue&type=template&id=59814444&scoped=true"
import script from "./TreatmentPlanForm.vue?vue&type=script&lang=js"
export * from "./TreatmentPlanForm.vue?vue&type=script&lang=js"

import "./TreatmentPlanForm.vue?vue&type=style&index=0&id=59814444&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59814444"]])

export default __exports__